:host {
  display: flex;
  flex-direction: column;
  gap: var-rem(--semantic-spacing-xs);

  @include media-header('from-md') {
    flex-direction: row;
    align-items: center;
  }
  @include media-header('until-md') {
    width: 100%;
  }

  wink-link {
    display: inline-flex;
  }
}
